module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAShJREFUOBFjZICC////KwCZtoyMjIuBbAkgOxMqBaOagXJ/gHIeQIFHQPY1kAQTiAAK8gOp+0CsAMQg8B+I/6FhkBgICALxVaAeHzAPRAA51UC8ES5AgAFUGwzEe0DKwC4A0ixAfAEkQCR4A1THClIL0ogBgKa3AwW5MCQYGLqAfn+KLI7VAKCCh0DMjqwQyv6JLobVAKAtM9AV4uJjNQDoBZALBLBosgEafhlZHKsBQAW6QMyIrBDK/owuhssAW6BCNiTFl4A230Xiw5m4DIgEquCGq2JgmAtkE28A0LYYJM14mbCEhFcRPkmYAX+BimTwKUSTEwPyFUFisDBYAmTfB0afCJAmlKSZgWqqgdgbiBFRBdQMypG5QAxSgA+AovcwMJz2ghQBAIF9Sp+4z9SDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/aorder.png
// module id = OHOA
// module chunks = 1